import React from 'react';
import { FamilyFinderProvider } from '../context/FamilyFinderContext';
import SupervisionOverviewPage from './SupervisionOverviewPage';

const SupervisionRoute = () => {
  return (
    <FamilyFinderProvider childId={null}>
      <SupervisionOverviewPage />
    </FamilyFinderProvider>
  );
};

export default SupervisionRoute;
